/*
    helper file converts rgb to hex and hex to rgb
*/


var ColorConverter = Class.create({
  	initialize: function() {
	},
	hexToRgb: function(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    },
    componentToHex: function(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex: function(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }
});

export let colorConverter = new ColorConverter();


// WEBPACK FOOTER //
// app/helpers/General/ColorConverter.js